module.exports = __webpack_public_path__ + "static/picture-3da9bc24ab35d409ef4f73760457e980.png";